(function () {
  if (window.__membershipStepCartAddBound) return;
  window.__membershipStepCartAddBound = true;

  let cachedSubscriptionLine = null;

  function parseIntSafe(value) {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  function normalizeSize(value) {
    return String(value || '')
      .split('(')[0]
      .trim()
      .toLowerCase();
  }

  function isMembershipPdp() {
    return Boolean(
      document.querySelector('.first-step .membership-step-button') ||
        document.querySelector('.membership_product')
    );
  }

  function isCityplayPdp() {
    if (document.body.classList.contains('cityplay-product-page')) return true;
    return [...document.body.classList].some((className) => className.includes('cityplay'));
  }

  function buildLineItemFromInput(input, quantity) {
    const variantId = input.getAttribute('data-variant');
    if (!variantId) return null;

    const id = parseIntSafe(variantId);
    if (!id) return null;

    const item = { id, quantity };
    const sellingPlan = input.getAttribute('data-selling_plan');
    if (sellingPlan) {
      const planId = parseIntSafe(sellingPlan);
      if (planId) item.selling_plan = planId;
    }
    return item;
  }

  function getKitInputs() {
    return [...document.querySelectorAll('.membership_product .annual_subscription_id, .annual_subscription_id')].filter(
      (input) => input.getAttribute('data-variant')
    );
  }

  function findSelectedKitInput() {
    const inputs = getKitInputs();
    if (!inputs.length) return null;

    const checked = document.querySelector('.first-step .size-option input[type="radio"]:checked');
    if (checked) {
      const sizeValue = checked.value;

      for (const input of inputs) {
        const variantTitle = input.getAttribute('data-variant-title');
        const optionValue = input.getAttribute('data-option-value');
        if (variantTitle === sizeValue || optionValue === sizeValue) return input;
      }

      const normalizedSize = normalizeSize(sizeValue);
      if (normalizedSize) {
        for (const input of inputs) {
          const variantTitle = normalizeSize(input.getAttribute('data-variant-title'));
          const optionValue = normalizeSize(input.getAttribute('data-option-value'));
          if (variantTitle === normalizedSize || optionValue === normalizedSize) return input;
          if (variantTitle.startsWith(normalizedSize) || optionValue.startsWith(normalizedSize)) return input;
        }
      }
    }

    const formVariantId = document.querySelector('.membership-form-variant-id')?.value;
    if (formVariantId) {
      const match = inputs.find((input) => input.getAttribute('data-variant') === formVariantId);
      if (match) return match;
    }

    const sizeRadios = document.querySelectorAll('.first-step .size-option input[type="radio"]');
    if (sizeRadios.length === 0 && inputs.length === 1) return inputs[0];

    return null;
  }

  function needsSizeSelection() {
    const sizeRadios = document.querySelectorAll('.first-step .size-option input[type="radio"]');
    const kitInputs = getKitInputs();
    if (!sizeRadios.length || kitInputs.length <= 1) return false;
    return ![...sizeRadios].some((radio) => radio.checked);
  }

  function getFixedTopInset() {
    let inset = 0;

    const saleBar = document.querySelector('.sale-announcementbar-sticky');
    if (saleBar) {
      const style = window.getComputedStyle(saleBar);
      if (style.display !== 'none' && style.visibility !== 'hidden') {
        const rect = saleBar.getBoundingClientRect();
        if (rect.height > 0) {
          const isPinned =
            saleBar.classList.contains('fixed-announcementbar') ||
            style.position === 'fixed' ||
            rect.top <= 2;
          if (isPinned) {
            inset = Math.max(inset, rect.height);
          } else if (rect.top >= 0 && rect.top < 120) {
            inset = Math.max(inset, rect.bottom);
          }
        }
      }
    }

    document
      .querySelectorAll(
        '#shopify-section-announcement-bar, .announcement-bar-section, sticky-header, .product_straps .product-header.mobile'
      )
      .forEach((el) => {
        const style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') return;
        const rect = el.getBoundingClientRect();
        if (rect.height > 0 && rect.top <= 8) {
          inset = Math.max(inset, rect.bottom);
        }
      });

    document.querySelectorAll('.shopify-section-group-header-group .shopify-section').forEach((section) => {
      const style = window.getComputedStyle(section);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      const rect = section.getBoundingClientRect();
      if (rect.top >= -4 && rect.top < 240 && rect.height > 0) {
        inset = Math.max(inset, rect.bottom);
      }
    });

    return inset + 16;
  }

  function scrollSizeHeadingIntoView(behavior = 'smooth') {
    const sizeLabel = document.querySelector('.first-step .size_label');
    if (!sizeLabel) {
      const fallback =
        document.querySelector('.first-step .size-option') || document.querySelector('.first-step');
      fallback?.scrollIntoView({ behavior, block: 'start' });
      return;
    }

    const inset = getFixedTopInset();
    sizeLabel.style.scrollMarginTop = `${inset}px`;
    document.documentElement.style.setProperty('--pdp-scroll-top-inset', `${inset}px`);

    const top = sizeLabel.getBoundingClientRect().top + window.scrollY - inset;
    window.scrollTo({ top: Math.max(0, top), behavior });
  }

  function scrollToMembershipBuySection() {
    const stickyBar = document.querySelector('.sticky-add-to-cart-btn');
    stickyBar?.classList.remove('fixed-sticky-btn');

    scrollSizeHeadingIntoView('smooth');
    window.setTimeout(() => scrollSizeHeadingIntoView('auto'), 600);
  }

  function highlightSizeOptions() {
    const sizeLabels = document.querySelectorAll('.size-option .input_variant');
    sizeLabels.forEach((label) => {
      label.classList.add('alter_border');
    });
    window.setTimeout(() => {
      sizeLabels.forEach((label) => label.classList.remove('alter_border'));
    }, 2200);
  }

  function showSizeRequiredMessage() {
    if (document.querySelector('.alert_text') || !document.querySelector('.size_label')) return;

    const warningText = document.createElement('div');
    warningText.textContent = 'Required to pick size';
    warningText.classList.add('alert_text');
    document.querySelector('.size_label').insertAdjacentElement('afterend', warningText);
    window.setTimeout(() => warningText.remove(), 2500);
  }

  function promptSelectSize() {
    highlightSizeOptions();
    scrollToMembershipBuySection();
    window.setTimeout(() => {
      showSizeRequiredMessage();
      scrollSizeHeadingIntoView('auto');
    }, 650);
  }

  window.promptSelectSize = promptSelectSize;
  window.scrollToMembershipBuySection = scrollToMembershipBuySection;

  function initMembershipSizeGate() {
    const addToCartBtn = document.querySelector('.membership-step-button');
    const stickyBtn = document.querySelector('.sticky-add-to-cart-btn .sticky-addToCart');
    const sizeRadios = document.querySelectorAll('.first-step .size-option input[type="radio"]');

    if (!addToCartBtn) return;

    function updateButtonState() {
      const kitInputs = getKitInputs();
      const needsSize = sizeRadios.length > 0 && kitInputs.length > 1;
      const hasSize = needsSize ? [...sizeRadios].some((radio) => radio.checked) : true;

      if (hasSize) {
        addToCartBtn.classList.remove('disabled_btn');
        stickyBtn?.classList.remove('disabled_btn');
        syncMembershipFormVariantId();
      } else {
        addToCartBtn.classList.add('disabled_btn');
        stickyBtn?.classList.add('disabled_btn');
      }
    }

    updateButtonState();
    sizeRadios.forEach((radio) => {
      radio.addEventListener('change', updateButtonState);
    });

    if (sizeRadios.length === 0) {
      syncMembershipFormVariantId();
    }
  }

  function syncMembershipFormVariantId() {
    const kitInput = findSelectedKitInput();
    const formVariantId = document.querySelector('.membership-form-variant-id');
    if (!formVariantId) return;
    formVariantId.value = kitInput?.getAttribute('data-variant') || '';
  }

  function getSubscriptionProductHandles() {
    const handles = [];
    const membershipRoot = document.querySelector('.membership_product');
    const primaryHandle = membershipRoot?.getAttribute('data-subscription-handle');
    if (primaryHandle) handles.push(primaryHandle);

    document.querySelectorAll('[data-membership-product-handle]').forEach((el) => {
      const handle = el.getAttribute('data-membership-product-handle');
      if (handle) handles.push(handle);
    });

    if (isCityplayPdp()) {
      handles.push('cityplay-subscription-recurley-commerce-copy');
    } else {
      handles.push('sample-pm-2-0-2-year');
    }

    return [...new Set(handles.filter(Boolean))];
  }

  function subscriptionLineFromMembershipRoot(quantity) {
    const root = document.querySelector('.membership_product');
    if (!root) return null;

    const id = parseIntSafe(root.getAttribute('data-subscription-variant-id'));
    const plan = parseIntSafe(root.getAttribute('data-subscription-selling-plan-id'));
    if (!id || !plan) return null;

    const qty = quantity > 0 ? quantity : 1;
    return { id, quantity: qty, selling_plan: plan };
  }

  function subscriptionLineFromHiddenInput(quantity) {
    const qty = quantity > 0 ? quantity : 1;
    const hidden = document.querySelector('.membership_subscription_id[data-selling_plan]');
    if (!hidden) return null;

    const itemQty = parseIntSafe(hidden.getAttribute('data-quantity')) || qty;
    const item = buildLineItemFromInput(hidden, itemQty);
    return item?.selling_plan ? item : null;
  }

  async function fetchSubscriptionLineItem(quantity) {
    if (cachedSubscriptionLine) {
      return { ...cachedSubscriptionLine, quantity: quantity > 0 ? quantity : 1 };
    }

    const fromRoot = subscriptionLineFromMembershipRoot(quantity);
    if (fromRoot) {
      cachedSubscriptionLine = {
        id: fromRoot.id,
        selling_plan: fromRoot.selling_plan,
        quantity: fromRoot.quantity,
      };
      return fromRoot;
    }

    const fromHidden = subscriptionLineFromHiddenInput(quantity);
    if (fromHidden) {
      cachedSubscriptionLine = { id: fromHidden.id, selling_plan: fromHidden.selling_plan, quantity: fromHidden.quantity };
      return fromHidden;
    }

    const qty = quantity > 0 ? quantity : 1;
    const handles = getSubscriptionProductHandles();

    for (const handle of handles) {
      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) continue;

        const product = await response.json();
        for (const variant of product.variants || []) {
          const allocation = variant.selling_plan_allocations?.[0];
          const sellingPlanId = allocation?.selling_plan_id;
          if (!sellingPlanId || !variant.id) continue;

          const line = {
            id: parseIntSafe(variant.id),
            quantity: qty,
            selling_plan: parseIntSafe(sellingPlanId),
          };
          cachedSubscriptionLine = { id: line.id, selling_plan: line.selling_plan, quantity: qty };
          return line;
        }
      } catch (err) {
        console.warn('Subscription product lookup failed for', handle, err);
      }
    }

    return null;
  }

  async function collectMembershipCartItems() {
    const itemsMap = new Map();
    const quantity = parseIntSafe(document.querySelector('.first-step .quantity__input')?.value) || 1;
    if (quantity < 1) return [];

    const sizeInput = findSelectedKitInput();
    const subscriptionItem = await fetchSubscriptionLineItem(quantity);
    let hasSeparateSubscription = Boolean(subscriptionItem?.selling_plan);

    if (sizeInput) {
      const item = buildLineItemFromInput(sizeInput, quantity);
      if (item) {
        const kitPlan = parseIntSafe(sizeInput.getAttribute('data-kit-selling_plan'));
        if (hasSeparateSubscription && subscriptionItem.id === item.id) {
          hasSeparateSubscription = false;
          item.selling_plan = subscriptionItem.selling_plan || kitPlan;
        } else if (!hasSeparateSubscription && kitPlan) {
          item.selling_plan = kitPlan;
        }
        itemsMap.set(`variant-${item.id}`, item);
      }
    }

    if (hasSeparateSubscription) {
      itemsMap.set(
        `selling-plan-${subscriptionItem.id}-${subscriptionItem.selling_plan}`,
        subscriptionItem
      );
    }

    return Array.from(itemsMap.values()).filter((item) => item.id > 0 && item.quantity > 0);
  }

  function refreshCartDrawerAndOpen(button) {
    const secId = 'cart-drawer';
    const intervalId = setInterval(() => {
      fetch(`${window.location.pathname}?sections=${secId}`)
        .then((res) => res.json())
        .then((data) => {
          const html = new DOMParser().parseFromString(data[secId], 'text/html');
          const drawer = document.querySelector('cart-drawer');
          const drawerHtml = html.querySelector('cart-drawer');
          if (drawer && drawerHtml) drawer.innerHTML = drawerHtml.innerHTML;

          button?.classList.remove('is-loading');
          document.querySelector('.sticky-add-to-cart-btn .sticky-addToCart')?.classList.remove('is-loading');

          fetch('/cart.js')
            .then((res) => res.json())
            .then((cart) => {
              document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
                const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
                const hiddenSpan = bubble.querySelector('.visually-hidden');
                if (visibleSpan) visibleSpan.textContent = cart.item_count;
                if (hiddenSpan) hiddenSpan.textContent = `${cart.item_count} items`;
                bubble.classList.toggle('double_bubble', cart.item_count > 9);
              });

              const qty = parseIntSafe(document.querySelector('.first-step .quantity__input')?.value) || 1;
              if (window.appliedProductDiscount && window.refreshProductDiscountPrices) {
                window.refreshProductDiscountPrices(qty);
              } else if (window.isCityplayProductPage?.() && window.renderCityplayProductPrices) {
                window.renderCityplayProductPrices(qty);
              }
            });

          clearInterval(intervalId);
        })
        .catch((err) => {
          console.error('Failed to update cart drawer section:', err);
          clearInterval(intervalId);
        });
    }, 200);

    setTimeout(() => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      cartDrawer.classList.remove('is-empty');
      cartDrawer.open();
    }, 500);
  }

  async function handleMembershipAdd(triggerButton) {
    if (!isMembershipPdp()) return false;

    const button = triggerButton || document.querySelector('.membership-step-button');
    if (!button) return false;

    if (button.classList.contains('disabled_btn') || needsSizeSelection()) {
      promptSelectSize();
      return false;
    }

    syncMembershipFormVariantId();
    const items = await collectMembershipCartItems();
    if (!items.length) {
      promptSelectSize();
      console.warn('Membership add to cart: select a size first.');
      return false;
    }

    const missingSellingPlan = items.every((item) => !item.selling_plan);
    if (missingSellingPlan) {
      console.warn(
        'Membership add to cart: subscription selling plan missing. Check membership product metafields or theme subscription handles.'
      );
    }

    button.classList.add('is-loading');
    document.querySelector('.sticky-add-to-cart-btn .sticky-addToCart')?.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items }),
    })
      .then(async (response) => {
        const text = await response.text();
        if (!response.ok) {
          throw new Error(text || `Cart add failed (${response.status})`);
        }
        return text;
      })
      .then(() => refreshCartDrawerAndOpen(button))
      .catch((err) => {
        console.error('Error adding products:', err);
        try {
          const parsed = JSON.parse(String(err.message || ''));
          if (parsed?.description) console.error(parsed.description);
        } catch (_parseErr) {
          /* ignore */
        }
        button.classList.remove('is-loading');
        document.querySelector('.sticky-add-to-cart-btn .sticky-addToCart')?.classList.remove('is-loading');
      });

    return true;
  }

  window.handleMembershipAdd = handleMembershipAdd;

  document.addEventListener(
    'submit',
    (e) => {
      if (!isMembershipPdp()) return;
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.dataset.type !== 'add-to-cart-form') return;
      e.preventDefault();
      e.stopPropagation();
    },
    true
  );

  document.addEventListener(
    'click',
    (e) => {
      const stickyBtn = e.target.closest('.sticky-addToCart[data-membership-sticky="true"]');
      if (stickyBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (needsSizeSelection()) {
          promptSelectSize();
          return;
        }
        const membershipBtn = document.querySelector('.membership-step-button');
        handleMembershipAdd(membershipBtn);
        return;
      }

      const disabledSticky = e.target.closest(
        '.sticky-add-to-cart-btn .sticky-addToCart.disabled_btn, .sticky-add-to-cart-btn .product-form__submit.disabled_btn'
      );
      if (disabledSticky && isMembershipPdp()) {
        e.preventDefault();
        e.stopPropagation();
        promptSelectSize();
        return;
      }

      const button = e.target.closest('.membership-step-button');
      if (!button || !button.closest('.first-step')) return;

      e.preventDefault();
      e.stopPropagation();
      handleMembershipAdd(button);
    },
    true
  );

  document.addEventListener('change', (e) => {
    if (!e.target.closest('.first-step .product-form__input')) return;
    syncMembershipFormVariantId();
  });

  document.addEventListener('DOMContentLoaded', () => {
    initMembershipSizeGate();
    syncMembershipFormVariantId();
  });
})();
